import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BeforeAfter } from "@/components/BeforeAfter";
import { Reveal, RevealStagger } from "@/components/Reveal";

const projets = [
  {
    title: "Rénovation de façade — Dordogne",
    desc: "Nettoyage et remise en peinture complète de la façade",
    before: "/realisations/facade1-avant.jpg",
    after: "/realisations/facade1-apres.jpg",
    alt: "rénovation façade Dordogne - HRC Rénovation",
  },
  {
    title: "Nettoyage de façade — Dordogne",
    desc: "Démoussage et traitement d'une façade fortement encrassée",
    before: "/realisations/facade2-avant.jpg",
    after: "/realisations/facade2-apres.jpg",
    alt: "nettoyage façade Dordogne - HRC Rénovation",
  },
  {
    /* TODO: Remplacer par la prochaine photo avant/après envoyée par Brandon */
    title: "Prochain chantier — photos à venir",
    desc: "D'autres réalisations arrivent bientôt",
    before: null,
    after: null,
    alt: "chantier rénovation Dordogne - HRC Rénovation",
  },
];

/* N'afficher que les chantiers avec de vraies photos avant/après.
   Tant qu'un chantier n'a pas ses deux photos, il n'apparaît pas ici
   (plutôt que d'afficher un bloc "photo à insérer" sur la page d'accueil). */
const projetsAvecPhotos = projets.filter((p) => p.before && p.after);

export const Realisations = () => (
  <section className="py-16 lg:py-28 bg-surface-canvas" data-testid="realisations-section">
    <div className="max-w-site mx-auto px-5 lg:px-6">
      <Reveal className="max-w-[640px] mb-12 lg:mb-16">
        <p className="micro-label mb-4">Réalisations</p>
        <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-[44px] leading-[1.1] text-brand-deep">
          Le travail parle mieux que les mots.
        </h2>
        <p className="mt-5 text-base md:text-lg text-ink-secondary">
          Quelques chantiers récents. Faites glisser le curseur pour voir la différence.
        </p>
      </Reveal>

      <RevealStagger
        className={`grid grid-cols-1 gap-6 max-w-[820px] ${projetsAvecPhotos.length > 1 ? "md:grid-cols-2" : ""}`}
      >
        {projetsAvecPhotos.map((p) => (
          <div key={p.title}>
            <div className="rounded-xl overflow-hidden border border-line shadow-subtle">
              <BeforeAfter beforeSrc={p.before} afterSrc={p.after} alt={p.alt} />
            </div>
            <p className="mt-4 font-medium text-sm text-brand-deep">{p.title}</p>
            <p className="mt-1 text-[13px] text-ink-tertiary">{p.desc}</p>
          </div>
        ))}
      </RevealStagger>

      <Reveal className="text-center mt-12">
        <Link to="/devis" className="btn-base btn-outline-deep" data-testid="realisations-more-btn">
          Voir plus de chantiers
          <ArrowRight size={18} aria-hidden="true" />
        </Link>
      </Reveal>
    </div>
  </section>
);
